module.exports = __webpack_public_path__ + "img/vippack.4155b5fa.png";